import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { formatRp } from "@/lib/api";
import { Wallet, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

const PRESETS = [20000, 50000, 100000, 200000];

function loadSnap(clientKey, production) {
  return new Promise((resolve, reject) => {
    if (window.snap) return resolve();
    const s = document.createElement("script");
    s.src = production
      ? "https://app.midtrans.com/snap/snap.js"
      : "https://app.sandbox.midtrans.com/snap/snap.js";
    s.setAttribute("data-client-key", clientKey);
    s.onload = () => resolve();
    s.onerror = () => reject(new Error("Gagal memuat Midtrans"));
    document.head.appendChild(s);
  });
}

export default function MidtransModal({ open, onOpenChange, onPaid }) {
  const [amount, setAmount] = useState(50000);
  const [loading, setLoading] = useState(false);

  const pay = async () => {
    if (amount < 10000) return toast.error("Minimal top up Rp10.000");
    setLoading(true);
    try {
      const { data: ck } = await api.get("/payments/midtrans/client-key");
      await loadSnap(ck.client_key, ck.production);
      const { data } = await api.post("/payments/midtrans/token", { amount_idr: amount });
      window.snap.pay(data.token, {
        onSuccess: () => { toast.success("Pembayaran berhasil!"); onPaid?.(); onOpenChange(false); },
        onPending: () => { toast.info("Menunggu pembayaran..."); onOpenChange(false); },
        onError: () => toast.error("Pembayaran gagal"),
        onClose: () => {},
      });
    } catch (e) {
      toast.error(e.response?.data?.detail || "Midtrans belum dikonfigurasi admin");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="glass-strong border-cyan-500/20 text-white max-w-md" data-testid="midtrans-modal">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2 text-xl">
            <Wallet className="text-cyan-400" /> Top Up Kredit
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-400 -mt-2">Bayar via QRIS, VA Bank, atau Kartu Kredit (Midtrans).</p>

        <div className="grid grid-cols-2 gap-3 mt-2">
          {PRESETS.map((p) => (
            <button key={p} onClick={() => setAmount(p)}
              data-testid={`topup-preset-${p}`}
              className={`p-3 rounded-xl border font-semibold transition-all
                ${amount === p ? "border-cyan-400 bg-cyan-950/40 text-cyan-300" : "border-slate-700/50 bg-slate-900/40 text-slate-300"}`}>
              {formatRp(p)}
            </button>
          ))}
        </div>

        <div className="mt-2">
          <label className="text-xs text-slate-400">Nominal lain</label>
          <input type="number" value={amount} min={10000} step={1000}
            onChange={(e) => setAmount(Number(e.target.value))}
            data-testid="topup-amount-input"
            className="w-full mt-1 bg-slate-900/60 border border-cyan-500/20 rounded-lg px-3 py-2 text-white font-mono" />
        </div>

        <Button onClick={pay} disabled={loading} className="btn-cyan text-white border-0 mt-3" data-testid="topup-pay-btn">
          {loading ? <Loader2 size={16} className="mr-2 animate-spin" /> : <Wallet size={16} className="mr-2" />}
          Bayar {formatRp(amount)}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
